import { render, staticRenderFns } from "./VePopup.vue?vue&type=template&id=2f956faa&scoped=true&"
import script from "./VePopup.vue?vue&type=script&lang=js&"
export * from "./VePopup.vue?vue&type=script&lang=js&"
import style0 from "./VePopup.vue?vue&type=style&index=0&id=2f956faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f956faa",
  null
  
)

export default component.exports